import Head from "next/head";
import PropTypes from "prop-types";
import { getCookieValue } from '../../../utils/helperServices';

function Seo({ title, metaTitle, content, url, keywords, robots }) {

  const isMiniApp = getCookieValue("miniApp") === "true";

  const defaultTitle = isMiniApp ? "Shop Online | Vodacom" : "";
  const defaultMetaTitle = isMiniApp? "Shop Online | Vodacom" : "";

  return (
    <Head>
      <title>{title || defaultTitle}</title>
      <meta name="title" content={metaTitle || defaultMetaTitle}/>
      <meta
        id="meta-description"
        name="description"
        content={content ? content : ""}
      />
      <link rel="canonical" href={url ? url : ""}></link>
      <meta name="keywords" content={keywords ? keywords : ""}></meta>
      <meta name="robots" content={robots ? robots : ""} />
    </Head>
  );
}

Seo.propTypes = {
  title: PropTypes.any,
  content: PropTypes.any,
  url: PropTypes.any,
  keywords: PropTypes.any,
  robots: PropTypes.any,
  metaTitle: PropTypes.any
};

export default Seo;
